import {BrowserRouter as Router, Link, Navigate, Route, Routes} from 'react-router-dom';
import utilStyles from "./styles/utils.module.css";
import Play from "./components/Play";
import React from 'react';
import Info from "./components/Info";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";

function App() {
    return (
        <Router>
            <div className="container">
                <header className='header'>
                    <h1 className={[utilStyles.princess, utilStyles.heading2Xl, utilStyles.center].join(' ')}>
                        <Link to='/'>Het Dautenmannetje</Link>
                    </h1>
                </header>

                <main className='main'>
                    <Routes>
                        <Route path='/' element={
                                <>
                                    <div className='hero'>
                                        <img
                                            src={process.env.PUBLIC_URL + '/images/dautenmannetje.png'}
                                            style={{ alignSelf: 'center' }}
                                            height="450" // Desired size with correct aspect ratio
                                            width="230" // Desired size with correct aspect ratio
                                            alt="Het Dautenmannetje"
                                        />
                                    </div>
                                    <Info/>
                                </>
                        }/>

                        <Route path='/afspelen/:id' element={<Play/>}/>
                        <Route path='/algemene-voorwaarden' element={<Terms/>}/>
                        <Route path='/privacy' element={<Privacy/>}/>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>

                <footer className='footer'>
                    <p>
                        Een project van &copy; <a href="https://www.willemclaesen.com" target="_blank"
                                                  rel="noopener noreferrer">Willem
                        Claesen</a>
                    </p>
                    <p>
                        In samenwerking met <a href="https://www.diepenbeek.be" target="_blank"
                                               rel="noopener noreferrer">Gemeente Diepenbeek</a>
                    </p>
                    <hr/>
                    <p>
                        <Link to='algemene-voorwaarden'>Algemene voorwaarden</Link> - <Link
                        to='privacy'>Privacybeleid</Link>
                    </p>
                </footer>
            </div>
        </Router>
    );
}

export default App;
